import { render, staticRenderFns } from "./editPeople.vue?vue&type=template&id=9d79a1a0&"
import script from "./editPeople.vue?vue&type=script&lang=js&"
export * from "./editPeople.vue?vue&type=script&lang=js&"
import style0 from "./editPeople.vue?vue&type=style&index=0&id=9d79a1a0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports